import { IconInfoCircle } from '@tabler/icons-react';
import {
  QualifyingLifeEventDto,
  QualifyingLifeEventType,
} from '@zorro/clients';
import { Tooltip } from '@zorro/design-system/v2/Tooltip';
import { parseDateISOThenFormatEnLocale } from '@zorro/shared/formatters';
import { qualifyingLifeEventLabelConfig } from '@zorro/types';
import { Center, Group, Icon, Stack, Text } from '@zorro/web/design-system';

type Props = {
  qualifyingLifeEvent?: Pick<
    QualifyingLifeEventDto,
    'type' | 'occurredOn' | 'otherReason'
  > | null;
  shouldShowTitle?: boolean;
};

export const QualifyingLifeEventLabel = ({
  qualifyingLifeEvent,
  shouldShowTitle = true,
}: Props) => {
  if (!qualifyingLifeEvent) {
    return null;
  }

  const label = qualifyingLifeEventLabelConfig[qualifyingLifeEvent.type];
  const date = parseDateISOThenFormatEnLocale(qualifyingLifeEvent.occurredOn);
  const isOtherReason =
    qualifyingLifeEvent.type === QualifyingLifeEventType.OTHER;

  return (
    <Stack gap="0.25rem">
      {shouldShowTitle && (
        <Text c="zorroGray.4" size="sm">
          QLE details
        </Text>
      )}
      <Group gap="0.25rem" align="center">
        <Tooltip
          disabled={!isOtherReason}
          inline
          label={
            <Stack gap={0}>
              <Text fw={600} size="sm">
                Employee's description:
              </Text>
              <Text size="sm">{qualifyingLifeEvent.otherReason}</Text>
            </Stack>
          }
        >
          <Text size="sm" display="inline">
            {label}
            {isOtherReason && (
              <Center inline ml="0.25rem" style={{ verticalAlign: 'top' }}>
                <Icon icon={IconInfoCircle} size="1.25rem" />
              </Center>
            )}
            , <Text size="sm">{date}</Text>
          </Text>
        </Tooltip>
      </Group>
    </Stack>
  );
};
